import React from 'react';
import '../styles/tavern-components.css';

export interface GroupEmblemProps {
  type?: 'dnd' | 'warhammer' | 'boardgames' | 'fencing' | 'default';
  className?: string;
}

/**
 * Group emblem/shield icon
 * 
 * @example
 * <GroupEmblem type="dnd" />
 * <GroupEmblem type="warhammer" />
 */
export function GroupEmblem({ type = 'default', className = '' }: GroupEmblemProps) {
  const typeClass = `group-emblem--${type}`;

  return <div className={`group-emblem ${typeClass} ${className}`.trim()} />;
}

export interface TavernSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

/**
 * Search input with tavern styling
 * 
 * @example
 * <TavernSearch 
 *   value={searchQuery}
 *   onChange={setSearchQuery}
 *   placeholder="Search groups..."
 * />
 */
export function TavernSearch({
  value,
  onChange,
  placeholder = 'Поиск...',
  className = '',
}: TavernSearchProps) {
  const hasValue = value.length > 0;

  return (
    <div className={`groups-search ${className}`.trim()}>
      <span className="groups-search-icon">🔍</span>
      <input
        type="text"
        className="groups-search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {hasValue && (
        <button
          type="button"
          className="groups-search-clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
}
